const testimonialSections = document.querySelectorAll(".testimonial-section");
testimonialSections.forEach((sliderSection, i) => {
  const slider = tns({
    container: sliderSection.querySelector(".slider"),
    items: 1,
    // center: true,
    autoplay: true,
    mode: 'gallery',
    controls: false,
    nav: false,
    //navContainer: sliderSection.querySelector('.team-slider-nav'),
    loop: true,
    autoplayButtonOutput: false,
    //controlsContainer: sliderSection.querySelector(".slider-controls"),
    fixedHeight: true,
    
  });
});